// import {
//   StyleSheet,
//   Text,
//   View,
//   Dimensions,
//   PixelRatio,
//   TouchableOpacity,
//   Platform,
// } from "react-native";
// import React from "react";
// import { Image } from "expo-image";
// import Colours from "../../utils/Colours";
// import { Ionicons } from "@expo/vector-icons";

// /* =========================
//    Responsive Helpers
// ========================= */
// const { width, height } = Dimensions.get("window");
// const BASE_WIDTH = 375;
// const BASE_HEIGHT = 812;

// const dynamicFontSize = (size) => {
//   const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
//   const newSize = size * scaleFactor;
//   return Math.round(PixelRatio.roundToNearestPixel(newSize));
// };

// const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;
// const dynamicSize = (size) => (width / BASE_WIDTH) * size;

// // 🎨 THEME MATRIX CONFIGURATIONS
// const GROUP_THEMES = {
//   Whales: { label: "WHALES", primary: "#D4AC0D" },
//   Ballers: { label: "BALLERS", primary: "#FF9900" },
//   "Active Tables": { label: "ACTIVE TABLES", primary: Colours.PRIMARY },
//   "Socially Active": { label: "SOCIALLY ACTIVE", primary: "#2ECC71" },
//   "Soft life": { label: "SOFT LIFE", primary: "#5DADE2" },
// };

// // 📂 ROBUST TEST DATA DATASET
// const mockTablesData = [
//   {
//     id: "1",
//     name: "OBO Table 01",
//     value: 1250000,
//     anonymous: false,
//     users: [
//       "https://api.dicebear.com/7.x/pixel-art/svg?seed=1",
//       "https://api.dicebear.com/7.x/pixel-art/svg?seed=2",
//     ],
//     topups: 5,
//     pictures: 12,
//     friendsTagged: 8,
//   },
//   {
//     id: "2",
//     name: "VVIP Lounge",
//     value: 890000,
//     anonymous: false,
//     users: ["https://api.dicebear.com/7.x/pixel-art/svg?seed=3"],
//     topups: 2,
//     pictures: 4,
//     friendsTagged: 1,
//   },
//   {
//     id: "3",
//     name: "Chop Life Crew",
//     value: 450000,
//     anonymous: false,
//     users: ["https://api.dicebear.com/7.x/pixel-art/svg?seed=a"],
//     topups: 9,
//     pictures: 25,
//     friendsTagged: 14,
//   },
//   {
//     id: "4",
//     name: "High Voltage Group",
//     value: 20000,
//     anonymous: true,
//     users: [],
//     topups: 1,
//     pictures: 1,
//     friendsTagged: 0,
//   },
//   {
//     id: "5",
//     name: "Frequency Boys",
//     value: 10000,
//     anonymous: false,
//     users: [
//       "https://api.dicebear.com/7.x/pixel-art/svg?seed=w,",
//       "https://api.dicebear.com/7.x/pixel-art/svg?seed=x,",
//       "https://api.dicebear.com/7.x/pixel-art/svg?seed=y,",
//     ],
//     topups: 3,
//     pictures: 2,
//     friendsTagged: 2,
//   },
//   {
//     id: "6",
//     name: "Paparazzi Central",
//     value: 15000,
//     anonymous: false,
//     users: ["https://api.dicebear.com/7.x/pixel-art/svg?seed=m"],
//     topups: 0,
//     pictures: 18,
//     friendsTagged: 9,
//   },
//   {
//     id: "7",
//     name: "Quiet Corner",
//     value: 5000,
//     anonymous: true,
//     users: [],
//     topups: 0,
//     pictures: 0,
//     friendsTagged: 0,
//   },
// ];

// const HigherTablesPage = () => {
//   const handleOpenTable = (item) => console.log("Opening table:", item.name);

//   // 🏷️ COMPACT CURRENCY CONVERSION ENGINE
//   const formatCompactCurrency = (value) => {
//     if (!value || isNaN(value)) return "₦0";
//     if (value >= 1000000) {
//       return `${Math.floor((value / 1000000) * 10) / 10}M+`;
//     }
//     if (value >= 1000) {
//       const roundedTens = Math.floor(value / 1000 / 10) * 10;
//       const displayK = roundedTens === 0 ? Math.floor(value / 1000) : roundedTens;
//       return `${displayK}K+`;
//     }
//     return `${value}`;
//   };

//   // ⚙️ CATEGORIZATION AND SORTING ENGINE pipeline
//   const processAndCategorizeTables = () => {
//     const categories = {
//       Whales: [],
//       Ballers: [],
//       "Active Tables": [],
//       "Socially Active": [],
//       "Soft life": [],
//     };

//     mockTablesData.forEach((table) => {
//       const spend = table.value || 0;

//       if (spend >= 900000) {
//         categories["Whales"].push(table);
//       } else if (spend >= 200000) {
//         categories["Ballers"].push(table);
//       } else if (table.topups > 0) {
//         categories["Active Tables"].push(table);
//       } else if (table.pictures > 0 || table.friendsTagged > 0) {
//         categories["Socially Active"].push(table);
//       } else {
//         categories["Soft life"].push(table);
//       }
//     });

//     categories["Whales"].sort((a, b) => b.value - a.value);
//     categories["Ballers"].sort((a, b) => b.value - a.value);
//     categories["Active Tables"].sort((a, b) => b.value - a.value);
//     categories["Socially Active"].sort(
//       (a, b) => b.pictures + b.friendsTagged - (a.pictures + a.friendsTagged),
//     );
//     categories["Soft life"].sort((a, b) => b.value - a.value);

//     return categories;
//   };

//   const processedDataCategories = processAndCategorizeTables();

//   const renderItem = ({ item, index, themeColor, category }) => {
//     return (
//       <View
//         key={item.id || index}
//         style={[
//           styles.tableCardContainer,
//           {
//             shadowColor: themeColor,
//             borderColor: Platform.OS === "android" ? "transparent" : "#F2F2F7",
//             borderWidth: Platform.OS === "android" ? 0 : 1,
//           },
//         ]}
//       >
//         <TouchableOpacity style={styles.rowCardContent} onPress={() => handleOpenTable(item)}>
//           {/* Rank Column */}
//           <Text style={styles.rank}>{index + 1}</Text>

//           {/* Core Table Metadata Description Information Block */}
//           <View style={styles.infoContainer}>
//             <Text style={styles.tableName}>{item.name}</Text>

//             <View style={styles.metricRowGroup}>
//               {/* CATEGORY METRIC CONDITIONAL CONTEXT RENDER SWITCH */}
//               {category === "Active Tables" ? (
//                 <View style={styles.metricRowGroupWrapped}>
//                   {/* 🏷️ BADGE 1: TOP UPS */}
//                   <View style={styles.activeCapsuleLabel}>
//                     <Ionicons
//                       name="trending-up"
//                       size={dynamicSize(10)}
//                       color={Colours.PRIMARY || "#333"}
//                       style={{ marginRight: 4 }}
//                     />
//                     <Text style={styles.activeLabelTxt}>Top ups</Text>
//                     <Text style={[styles.activeValueTxt, { color: themeColor }]}>
//                       {" "}
//                       {/* {item.topups}Tops */}
//                       {item.topups}
//                     </Text>
//                   </View>

//                   {/* ⚪ THE SEPARATOR DOT */}
//                   <View style={styles.miniSeparatorDot} />

//                   {/* 💰 BADGE 2: VOLTAGE */}
//                   <View
//                     style={[
//                       styles.activeCapsuleTag,
//                       { backgroundColor: `${themeColor}10`, borderColor: `${themeColor}40` },
//                     ]}
//                   >
//                     <Ionicons
//                       name="flash"
//                       size={dynamicSize(11)}
//                       color="#FF9900"
//                       style={{ marginRight: dynamicSpacing(3) }}
//                     />
//                     <Text style={styles.activeLabelTxt}>Voltage</Text>
//                     <Text style={styles.voltageValueTxt}>
//                       {" "}
//                       {Math.round(item.value / 200)} Volts
//                     </Text>
//                   </View>
//                 </View>
//               ) : category === "Socially Active" ? (
//                 <>
//                   {/* Photo Pipeline Counter Tag Indicator */}
//                   <View style={styles.labelCapsuleTag}>
//                     <Ionicons
//                       name="camera"
//                       size={dynamicSize(12)}
//                       color={Colours.PRIMARY}
//                       style={{ marginRight: 4 }}
//                     />
//                     <Text style={styles.valueLabelTxt}>{`${item.pictures} Pics`}</Text>
//                   </View>
//                   <View style={styles.miniSeparatorDot} />
//                   {/* Friend Tags metrics system element */}
//                   <View
//                     style={[
//                       styles.amountCapsuleTag,
//                       { backgroundColor: `${themeColor}15`, borderColor: `${themeColor}40` },
//                     ]}
//                   >
//                     <Text
//                       style={[
//                         styles.slantedVividAmount,
//                         { color: themeColor, fontStyle: "normal" },
//                       ]}
//                     >
//                       <Ionicons name="people" size={dynamicSize(11)} color={themeColor} />
//                       {` ${item.friendsTagged} Tagged`}
//                     </Text>
//                   </View>
//                 </>
//               ) : (
//                 <>
//                   {/* Standard Financial Base Metric Tag Container Design (Whales, Ballers, Soft Life) */}
//                   <View style={styles.labelCapsuleTag}>
//                     <Ionicons
//                       name="trending-up"
//                       size={dynamicSize(12)}
//                       color={Colours.PRIMARY || "#333"}
//                       style={{ marginRight: 4 }}
//                     />
//                     <Text style={styles.valueLabelTxt}>Table Value</Text>
//                   </View>
//                   <View style={styles.miniSeparatorDot} />
//                   <View
//                     style={[
//                       styles.amountCapsuleTag,
//                       { backgroundColor: `${themeColor}15`, borderColor: `${themeColor}40` },
//                     ]}
//                   >
//                     <Text style={[styles.slantedVividAmount, { color: themeColor }]}>
//                       {formatCompactCurrency(item.value)}
//                     </Text>
//                   </View>
//                 </>
//               )}
//             </View>
//           </View>

//           {/* User Stack Layer Allocation Module */}
//           {item.anonymous ? (
//             <Text style={styles.anonymous}>A/N</Text>
//           ) : (
//             <View style={styles.avatarStack}>
//               {item.users &&
//                 item.users
//                   .slice(0, 4)
//                   .map((avatar, i) => (
//                     <Image
//                       key={i}
//                       source={{ uri: avatar }}
//                       style={[styles.avatar, { marginLeft: i === 0 ? 0 : -dynamicSpacing(12) }]}
//                     />
//                   ))}
//             </View>
//           )}
//         </TouchableOpacity>
//       </View>
//     );
//   };

//   // 🔥 Strictly rearranged target tiers array to place Socially Active below Soft Life
//   const targetTiers = ["Whales", "Ballers", "Active Tables", "Soft life", "Socially Active"];

//   return (
//     <View style={styles.listWrapperBlock}>
//       {targetTiers.map((tierName) => {
//         const groupItems = processedDataCategories[tierName];
//         if (!groupItems || groupItems.length === 0) return null;

//         const theme = GROUP_THEMES[tierName];

//         return (
//           <View key={tierName} style={styles.groupContainerBlock}>
//             {/* Live Header Indicator */}
//             <View style={styles.liveIndicatorContainer}>
//               <View style={[styles.liveDotPulse, { backgroundColor: theme.primary }]} />
//               <Text style={styles.liveIndicatorText}>{theme.label}</Text>
//             </View>

//             {/* List Pipeline Stack Wrapper */}
//             <View style={styles.cardsStackWrapper}>
//               {groupItems.map((tableItem, index) =>
//                 renderItem({
//                   item: tableItem,
//                   index: index,
//                   themeColor: theme.primary,
//                   category: tierName,
//                 }),
//               )}
//             </View>
//           </View>
//         );
//       })}
//     </View>
//   );
// };

// export default HigherTablesPage;

// const styles = StyleSheet.create({
//   listWrapperBlock: {
//     paddingTop: dynamicSpacing(10),
//     paddingHorizontal: dynamicSpacing(4),
//   },
//   groupContainerBlock: {
//     marginBottom: dynamicSpacing(20),
//   },
//   cardsStackWrapper: {
//     marginTop: dynamicSpacing(10),
//   },
//   liveIndicatorContainer: {
//     flexDirection: "row",
//     alignItems: "center",
//     gap: dynamicSpacing(6),
//     paddingHorizontal: dynamicSpacing(4),
//     marginVertical: dynamicSpacing(4),
//   },
//   liveDotPulse: {
//     width: dynamicSize(8),
//     height: dynamicSize(8),
//     borderRadius: 50,
//   },
//   liveIndicatorText: {
//     fontSize: dynamicFontSize(11),
//     fontFamily: "Sen-Bold",
//     color: "#666",
//     letterSpacing: 0.5,
//   },
//   tableCardContainer: {
//     backgroundColor: "white",
//     borderRadius: dynamicSize(14),
//     marginBottom: dynamicSpacing(14),
//     paddingHorizontal: dynamicSpacing(14),
//     paddingVertical: dynamicSpacing(14),
//     shadowOffset: { width: 0, height: 6 },
//     shadowOpacity: 0.12,
//     shadowRadius: 10,
//     elevation: 4,
//   },
//   rowCardContent: {
//     flexDirection: "row",
//     alignItems: "center",
//   },
//   rank: {
//     fontSize: dynamicFontSize(18),
//     fontFamily: "Sen-Bold",
//     color: "#C8C8C8",
//     width: dynamicSpacing(28),
//   },
//   infoContainer: {
//     flex: 1,
//     paddingRight: dynamicSpacing(8),
//   },
//   tableName: {
//     fontSize: dynamicFontSize(15),
//     fontFamily: "Sen-Bold",
//     color: "#1F1F1F",
//   },
//   metricRowGroup: {
//     flexDirection: "row",
//     alignItems: "center",
//     marginTop: dynamicSpacing(6),
//   },
//   labelCapsuleTag: {
//     flexDirection: "row",
//     alignItems: "center",
//     backgroundColor: "#F2F2F7",
//     paddingHorizontal: dynamicSpacing(8),
//     paddingVertical: dynamicSpacing(4),
//     borderRadius: dynamicSize(6),
//   },
//   valueLabelTxt: {
//     fontSize: dynamicFontSize(11),
//     fontFamily: "Sen-Regular",
//     color: "#666",
//   },
//   miniSeparatorDot: {
//     width: dynamicSize(4),
//     height: dynamicSize(4),
//     borderRadius: dynamicSize(2),
//     backgroundColor: "#D1D1D6",
//     marginHorizontal: dynamicSpacing(8),
//     alignSelf: "center",
//   },
//   amountCapsuleTag: {
//     paddingHorizontal: dynamicSpacing(10),
//     paddingVertical: dynamicSpacing(4),
//     borderRadius: dynamicSize(6),
//     borderWidth: 0.8,
//   },
//   slantedVividAmount: {
//     fontSize: dynamicFontSize(13),
//     fontFamily: "Sen-Bold",
//     letterSpacing: 0.3,
//   },
//   avatarStack: {
//     flexDirection: "row",
//     alignItems: "center",
//     justifyContent: "flex-end",
//     minWidth: dynamicSize(70),
//     paddingLeft: dynamicSpacing(4),
//   },
//   avatar: {
//     width: dynamicSize(30),
//     height: dynamicSize(30),
//     borderRadius: dynamicSize(15),
//     borderWidth: 1.5,
//     borderColor: "white",
//   },
//   anonymous: {
//     fontSize: dynamicFontSize(12),
//     color: "#9E9E9E",
//     fontFamily: "Sen-Regular",
//   },
//   activeCapsuleTag: {
//     flexDirection: "row",
//     alignItems: "center",
//     backgroundColor: "#F2F2F7",
//     paddingHorizontal: dynamicSpacing(8),
//     paddingVertical: dynamicSpacing(4),
//     borderRadius: dynamicSize(6),
//     borderWidth: 0.8,
//   },
//   activeCapsuleLabel: {
//     flexDirection: "row",
//     alignItems: "center",
//     backgroundColor: "#F2F2F7",
//     paddingHorizontal: dynamicSpacing(8),
//     paddingVertical: dynamicSpacing(4),
//     borderRadius: dynamicSize(6),
//   },
//   activeLabelTxt: {
//     fontSize: dynamicFontSize(11),
//     fontFamily: "Sen-Regular",
//     color: "#666667",
//   },
//   activeValueTxt: {
//     fontSize: dynamicFontSize(13),
//     fontFamily: "Sen-Bold",
//   },
//   voltageValueTxt: {
//     fontSize: dynamicFontSize(13),
//     fontFamily: "Sen-Bold",
//     color: Colours.PRIMARY,
//   },
//   metricRowGroupWrapped: {
//     flexDirection: "row",
//     alignItems: "center",
//     flexWrap: "wrap",
//     marginTop: dynamicSpacing(6),
//     gap: dynamicSpacing(2),
//   },
// });

import {
  StyleSheet,
  Text,
  View,
  Dimensions,
  PixelRatio,
  TouchableOpacity,
  Platform,
  Animated, // 🔥 Added for the moving live wave motion loop
} from "react-native";
import React, { useEffect, useRef } from "react";
import { Image } from "expo-image";
import Colours from "../../utils/Colours";
import { Ionicons } from "@expo/vector-icons";

/* =========================
   Responsive Helpers
========================= */
const { width, height } = Dimensions.get("window");
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  const newSize = size * scaleFactor;
  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

// 🎨 THEME MATRIX CONFIGURATIONS
const GROUP_THEMES = {
  Whales: { label: "WHALES", primary: "#D4AC0D" },
  Ballers: { label: "BALLERS", primary: "#FF9900" },
  "Active Tables": { label: "ACTIVE TABLES", primary: Colours.PRIMARY },
  "Socially Active": { label: "SOCIALLY ACTIVE", primary: "#2ECC71" },
  "Soft life": { label: "SOFT LIFE", primary: "#5DADE2" },
};

// 📂 ROBUST TEST DATA DATASET
const mockTablesData = [
  {
    id: "1",
    name: "OBO Table 01",
    value: 1250000,
    anonymous: false,
    users: [
      "https://api.dicebear.com/7.x/pixel-art/svg?seed=1",
      "https://api.dicebear.com/7.x/pixel-art/svg?seed=2",
    ],
    topups: 5,
    pictures: 12,
    friendsTagged: 8,
  },
  {
    id: "2",
    name: "VVIP Lounge",
    value: 890000,
    anonymous: false,
    users: ["https://api.dicebear.com/7.x/pixel-art/svg?seed=3"],
    topups: 2,
    pictures: 4,
    friendsTagged: 1,
  },
  {
    id: "3",
    name: "Chop Life Crew",
    value: 450000,
    anonymous: false,
    users: ["https://api.dicebear.com/7.x/pixel-art/svg?seed=a"],
    topups: 9,
    pictures: 25,
    friendsTagged: 14,
  },
  {
    id: "4",
    name: "High Voltage Group",
    value: 20000,
    anonymous: true,
    users: [],
    topups: 1,
    pictures: 1,
    friendsTagged: 0,
  },
  {
    id: "5",
    name: "Frequency Boys",
    value: 10000,
    anonymous: false,
    users: [
      "https://api.dicebear.com/7.x/pixel-art/svg?seed=w,",
      "https://api.dicebear.com/7.x/pixel-art/svg?seed=x,",
      "https://api.dicebear.com/7.x/pixel-art/svg?seed=y,",
    ],
    topups: 3,
    pictures: 2,
    friendsTagged: 2,
  },
  {
    id: "6",
    name: "Paparazzi Central",
    value: 15000,
    anonymous: false,
    users: ["https://api.dicebear.com/7.x/pixel-art/svg?seed=m"],
    topups: 0,
    pictures: 18,
    friendsTagged: 9,
  },
  {
    id: "7",
    name: "Quiet Corner",
    value: 120000,
    anonymous: true,
    users: [],
    topups: 0,
    pictures: 0,
    friendsTagged: 0,
  },
];

// ⚡ LIVE VERTICAL FEED DATASET FOR TOP-UPS SECTION
const mockLiveTopupsFeed = [
  { id: "feed_1", name: "OBO Table 01", amount: 150000, time: "Just now" },
  { id: "feed_2", name: "Chop Life Crew", amount: 65000, time: "2m ago" },
  { id: "feed_3", name: "Frequency Boys", amount: 45000, time: "5m ago" },
];

const HigherTablesPage = () => {
  const handleOpenTable = (item) => console.log("Opening table:", item.name);

  // 🏷️ COMPACT CURRENCY CONVERSION ENGINE
  const formatCompactCurrency = (value) => {
    if (!value || isNaN(value)) return "₦0";
    if (value >= 1000000) {
      return `${Math.floor((value / 1000000) * 10) / 10}M+`;
    }
    if (value >= 1000) {
      const roundedTens = Math.floor(value / 1000 / 10) * 10;
      const displayK = roundedTens === 0 ? Math.floor(value / 1000) : roundedTens;
      return `${displayK}K+`;
    }
    return `${value}`;
  };

  // 📡 INFINITE WAVE RADAR ANIMATION LOOP FOR THE LIVE INDICATOR
  const waveAnimValue = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    Animated.loop(
      Animated.timing(waveAnimValue, {
        toValue: 1,
        duration: 1800,
        useNativeDriver: Platform.OS !== "web", // Safe configuration choice for PWA environments
      }),
    ).start();
  }, [waveAnimValue]);

  const waveScale = waveAnimValue.interpolate({
    inputRange: [0, 1],
    outputRange: [1, 2.5],
  });

  const waveOpacity = waveAnimValue.interpolate({
    inputRange: [0, 0.8, 1],
    outputRange: [0.6, 0.4, 0],
  });

  // 🎨 COLOR DECISION ROUTER FOR SOLID FULL BACKGROUND BADGES
  const getTickerBadgeColor = (amount) => {
    if (amount >= 100000) return Colours.PRIMARY || "#800020"; // 100k+
    if (amount >= 50000) return "#5DADE2"; // 50k to 100k Blue
    return "#2ECC71"; // 20k to 50k Green
  };

  // ⚙️ CATEGORIZATION AND SORTING ENGINE pipeline
  const processAndCategorizeTables = () => {
    const categories = {
      Whales: [],
      Ballers: [],
      "Active Tables": [],
      "Socially Active": [],
      "Soft life": [],
    };

    mockTablesData.forEach((table) => {
      const spend = table.value || 0;

      if (spend >= 900000) {
        categories["Whales"].push(table);
      } else if (spend >= 200000) {
        categories["Ballers"].push(table);
      } else if (table.topups > 0) {
        categories["Active Tables"].push(table);
      } else if (table.pictures > 0 || table.friendsTagged > 0) {
        categories["Socially Active"].push(table);
      } else {
        categories["Soft life"].push(table);
      }
    });

    categories["Whales"].sort((a, b) => b.value - a.value);
    categories["Ballers"].sort((a, b) => b.value - a.value);
    categories["Active Tables"].sort((a, b) => b.value - a.value);
    categories["Socially Active"].sort(
      (a, b) => b.pictures + b.friendsTagged - (a.pictures + a.friendsTagged),
    );
    categories["Soft life"].sort((a, b) => b.value - a.value);

    return categories;
  };

  const processedDataCategories = processAndCategorizeTables();

  const renderItem = ({ item, index, themeColor, category }) => {
    return (
      <View
        key={item.id || index}
        style={[
          styles.tableCardContainer,
          {
            shadowColor: themeColor,
            borderColor: Platform.OS === "android" ? "transparent" : "#F2F2F7",
            borderWidth: Platform.OS === "android" ? 0 : 1,
          },
        ]}
      >
        <TouchableOpacity style={styles.rowCardContent} onPress={() => handleOpenTable(item)}>
          {/* Rank Column */}
          <Text style={styles.rank}>{index + 1}</Text>

          {/* Core Table Metadata Description Information Block */}
          <View style={styles.infoContainer}>
            <Text style={styles.tableName}>{item.name}</Text>

            <View style={styles.metricRowGroup}>
              {/* CATEGORY METRIC CONDITIONAL CONTEXT RENDER SWITCH */}
              {category === "Active Tables" ? (
                <View style={styles.metricRowGroupWrapped}>
                  {/* 🏷️ BADGE 1: TOP UPS */}
                  <View style={styles.activeCapsuleLabel}>
                    <Ionicons
                      name="trending-up"
                      size={dynamicSize(10)}
                      color={Colours.PRIMARY || "#333"}
                      style={{ marginRight: 4 }}
                    />
                    <Text style={styles.activeLabelTxt}>Top ups</Text>
                    <Text style={[styles.activeValueTxt, { color: themeColor }]}>
                      {" "}
                      {item.topups}
                    </Text>
                  </View>

                  {/* ⚪ THE SEPARATOR DOT */}
                  <View style={styles.miniSeparatorDot} />

                  {/* 💰 BADGE 2: VOLTAGE */}
                  <View
                    style={[
                      styles.activeCapsuleTag,
                      { backgroundColor: `${themeColor}10`, borderColor: `${themeColor}40` },
                    ]}
                  >
                    <Ionicons
                      name="flash"
                      size={dynamicSize(11)}
                      color="#FF9900"
                      style={{ marginRight: dynamicSpacing(3) }}
                    />
                    <Text style={styles.activeLabelTxt}>Voltage</Text>
                    <Text style={styles.voltageValueTxt}>
                      {" "}
                      {Math.round(item.value / 200)} Volts
                    </Text>
                  </View>
                </View>
              ) : category === "Socially Active" ? (
                <>
                  {/* Photo Pipeline Counter Tag Indicator */}
                  <View style={styles.labelCapsuleTag}>
                    <Ionicons
                      name="camera"
                      size={dynamicSize(12)}
                      color={Colours.PRIMARY}
                      style={{ marginRight: 4 }}
                    />
                    <Text style={styles.valueLabelTxt}>{`${item.pictures} Pics`}</Text>
                  </View>
                  <View style={styles.miniSeparatorDot} />
                  {/* Friend Tags metrics system element */}
                  <View
                    style={[
                      styles.amountCapsuleTag,
                      { backgroundColor: `${themeColor}15`, borderColor: `${themeColor}40` },
                    ]}
                  >
                    <Text
                      style={[
                        styles.slantedVividAmount,
                        { color: themeColor, fontStyle: "normal" },
                      ]}
                    >
                      <Ionicons name="people" size={dynamicSize(11)} color={themeColor} />
                      {` ${item.friendsTagged} Tagged`}
                    </Text>
                  </View>
                </>
              ) : (
                <>
                  {/* Standard Financial Base Metric Tag Container Design (Whales, Ballers, Soft Life) */}
                  <View style={styles.labelCapsuleTag}>
                    <Ionicons
                      name="trending-up"
                      size={dynamicSize(12)}
                      color={Colours.PRIMARY || "#333"}
                      style={{ marginRight: 4 }}
                    />
                    <Text style={styles.valueLabelTxt}>Table Value</Text>
                  </View>
                  <View style={styles.miniSeparatorDot} />
                  <View
                    style={[
                      styles.amountCapsuleTag,
                      { backgroundColor: `${themeColor}15`, borderColor: `${themeColor}40` },
                    ]}
                  >
                    <Text style={[styles.slantedVividAmount, { color: themeColor }]}>
                      {formatCompactCurrency(item.value)}
                    </Text>
                  </View>
                </>
              )}
            </View>
          </View>

          {/* User Stack Layer Allocation Module */}
          {item.anonymous ? (
            <Text style={styles.anonymous}>A/N</Text>
          ) : (
            <View style={styles.avatarStack}>
              {item.users &&
                item.users
                  .slice(0, 4)
                  .map((avatar, i) => (
                    <Image
                      key={i}
                      source={{ uri: avatar }}
                      style={[styles.avatar, { marginLeft: i === 0 ? 0 : -dynamicSpacing(12) }]}
                    />
                  ))}
            </View>
          )}
        </TouchableOpacity>
      </View>
    );
  };

  // 🔥 Strictly rearranged target tiers array to place Socially Active below Soft Life
  const targetTiers = ["Whales", "Ballers", "Active Tables", "Soft life", "Socially Active"];

  return (
    <View style={styles.listWrapperBlock}>
      {/* ── ⚡ NEW LIVE TABLE TOP-UPS SECTION (PLACED ON TOP BEFORE WHALES) ── */}
      <View style={styles.tickerOuterWrapper}>
        <View style={styles.tickerHeaderRow}>
          <View style={styles.liveIndicatorContainer}>
            {/* Facebook Live-Style Radio Transmitting Wave Effect */}
            <View style={styles.waveNodeLayout}>
              <Animated.View
                style={[
                  styles.liveWaveRing,
                  { transform: [{ scale: waveScale }], opacity: waveOpacity },
                ]}
              />
              <View style={styles.liveWaveCenter} />
            </View>
            <Text style={styles.liveIndicatorText}>LIVE TABLE TOP-UPS</Text>
          </View>
          <Text style={styles.tickerSubLink}>Activity Feed</Text>
        </View>

        {/* Vertical Feed Container Design */}
        <View style={styles.verticalFeedStackContainer}>
          {mockLiveTopupsFeed.map((feedItem, index) => {
            const dynamicColorTheme = getTickerBadgeColor(feedItem.amount);
            const isMostRecent = index === 0;

            return (
              <View key={feedItem.id} style={styles.liveVerticalItemRow}>
                {/* Left Section: Meta Texts & Replacing Avatars with Balloon Asset for Newest Item */}
                <View style={styles.liveVerticalItemLeft}>
                  {isMostRecent ? (
                    <View style={styles.waveNodeLayout}>
                      <Animated.View
                        style={[
                          styles.toppingWaveRing,
                          { transform: [{ scale: waveScale }], opacity: waveOpacity },
                        ]}
                      />
                      <View style={styles.toppingWaveCenter} />
                    </View>
                  ) : (
                    <View style={styles.balloonSpaceReplacerDot} />
                  )}

                  <View style={styles.metaTextBlock}>
                    <Text style={styles.liveCardTableName}>{feedItem.name}</Text>
                    <Text style={styles.liveCardToppingLabel}>Top up</Text>
                  </View>
                </View>

                {/* Right Section: Borderless Full Capsule Amount Badge & Time Stamp */}
                <View style={styles.liveVerticalItemRight}>
                  <View
                    style={[styles.tickerFullSolidCapsule, { backgroundColor: dynamicColorTheme }]}
                  >
                    <Text style={styles.tickerFullCapsuleText}>
                      {formatCompactCurrency(feedItem.amount)}
                    </Text>
                  </View>
                  <Text style={styles.liveCardTimeText}>{feedItem.time}</Text>
                </View>
              </View>
            );
          })}
        </View>
      </View>

      {/* ── EXISTING DESIGN: MASTER TIERS RENDER PIPELINE ── */}
      {targetTiers.map((tierName) => {
        const groupItems = processedDataCategories[tierName];
        if (!groupItems || groupItems.length === 0) return null;

        const theme = GROUP_THEMES[tierName];

        return (
          <View key={tierName} style={styles.groupContainerBlock}>
            {/* Live Header Indicator */}
            <View style={styles.liveIndicatorContainer}>
              <View style={[styles.liveDotPulse, { backgroundColor: theme.primary }]} />
              <Text style={styles.liveIndicatorText}>{theme.label}</Text>
            </View>

            {/* List Pipeline Stack Wrapper */}
            <View style={styles.cardsStackWrapper}>
              {groupItems.map((tableItem, index) =>
                renderItem({
                  item: tableItem,
                  index: index,
                  themeColor: theme.primary,
                  category: tierName,
                }),
              )}
            </View>
          </View>
        );
      })}
    </View>
  );
};

export default HigherTablesPage;

const styles = StyleSheet.create({
  listWrapperBlock: {
    paddingTop: dynamicSpacing(10),
    paddingHorizontal: dynamicSpacing(4),
  },
  groupContainerBlock: {
    marginBottom: dynamicSpacing(20),
  },
  cardsStackWrapper: {
    marginTop: dynamicSpacing(10),
  },
  liveIndicatorContainer: {
    flexDirection: "row",
    alignItems: "center",
    gap: dynamicSpacing(6),
    // paddingHorizontal: dynamicSpacing(4),
    marginVertical: dynamicSpacing(4),
  },
  liveDotPulse: {
    width: dynamicSize(8),
    height: dynamicSize(8),
    borderRadius: 50,
  },
  liveIndicatorText: {
    fontSize: dynamicFontSize(11),
    fontFamily: "Sen-Bold",
    color: "#666",
    letterSpacing: 0.5,
  },
  tableCardContainer: {
    backgroundColor: "white",
    borderRadius: dynamicSize(14),
    marginBottom: dynamicSpacing(14),
    paddingHorizontal: dynamicSpacing(14),
    paddingVertical: dynamicSpacing(14),
    shadowOffset: { width: 0, height: 6 },
    shadowOpacity: 0.12,
    shadowRadius: 10,
    elevation: 4,
  },
  rowCardContent: {
    flexDirection: "row",
    alignItems: "center",
  },
  rank: {
    fontSize: dynamicFontSize(18),
    fontFamily: "Sen-Bold",
    color: "#C8C8C8",
    width: dynamicSpacing(28),
  },
  infoContainer: {
    flex: 1,
    paddingRight: dynamicSpacing(8),
  },
  tableName: {
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Bold",
    color: "#1F1F1F",
  },
  metricRowGroup: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: dynamicSpacing(6),
  },
  labelCapsuleTag: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#F2F2F7",
    paddingHorizontal: dynamicSpacing(8),
    paddingVertical: dynamicSpacing(4),
    borderRadius: dynamicSize(6),
  },
  valueLabelTxt: {
    fontSize: dynamicFontSize(11),
    fontFamily: "Sen-Regular",
    color: "#666",
  },
  miniSeparatorDot: {
    width: dynamicSize(4),
    height: dynamicSize(4),
    borderRadius: dynamicSize(2),
    backgroundColor: "#D1D1D6",
    marginHorizontal: dynamicSpacing(8),
    alignSelf: "center",
  },
  amountCapsuleTag: {
    paddingHorizontal: dynamicSpacing(10),
    paddingVertical: dynamicSpacing(4),
    borderRadius: dynamicSize(6),
    borderWidth: 0.8,
  },
  slantedVividAmount: {
    fontSize: dynamicFontSize(13),
    fontFamily: "Sen-Bold",
    letterSpacing: 0.3,
  },
  avatarStack: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
    minWidth: dynamicSize(70),
    paddingLeft: dynamicSpacing(4),
  },
  avatar: {
    width: dynamicSize(30),
    height: dynamicSize(30),
    borderRadius: dynamicSize(15),
    borderWidth: 1.5,
    borderColor: "white",
  },
  anonymous: {
    fontSize: dynamicFontSize(12),
    color: "#9E9E9E",
    fontFamily: "Sen-Regular",
  },
  activeCapsuleTag: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#F2F2F7",
    paddingHorizontal: dynamicSpacing(8),
    paddingVertical: dynamicSpacing(4),
    borderRadius: dynamicSize(6),
    borderWidth: 0.8,
  },
  activeCapsuleLabel: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#F2F2F7",
    paddingHorizontal: dynamicSpacing(8),
    paddingVertical: dynamicSpacing(4),
    borderRadius: dynamicSize(6),
  },
  activeLabelTxt: {
    fontSize: dynamicFontSize(11),
    fontFamily: "Sen-Regular",
    color: "#666667",
  },
  activeValueTxt: {
    fontSize: dynamicFontSize(13),
    fontFamily: "Sen-Bold",
  },
  voltageValueTxt: {
    fontSize: dynamicFontSize(13),
    fontFamily: "Sen-Bold",
    color: Colours.PRIMARY,
  },
  metricRowGroupWrapped: {
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
    marginTop: dynamicSpacing(6),
    gap: dynamicSpacing(2),
  },

  // ── 📡 RADIO TRANSMITTING CONTINUOUS LIVE WAVE EMITTER ──
  waveNodeLayout: {
    width: dynamicSize(16),
    height: dynamicSize(16),
    justifyContent: "center",
    alignItems: "center",
    marginRight: dynamicSpacing(2),
  },
  liveWaveCenter: {
    width: dynamicSize(8),
    height: dynamicSize(8),
    borderRadius: 4,
    backgroundColor: "#2ECC71",
    position: "absolute",
    zIndex: 2,
  },
  liveWaveRing: {
    width: dynamicSize(10),
    height: dynamicSize(10),
    borderRadius: 50,
    borderWidth: 1.5,
    borderColor: "#2ECC71",
    position: "absolute",
    zIndex: 1,
  },
  toppingWaveCenter: {
    width: dynamicSize(8),
    height: dynamicSize(8),
    borderRadius: 4,
    backgroundColor: Colours.PRIMARY,
    position: "absolute",
    zIndex: 2,
  },
  toppingWaveRing: {
    width: dynamicSize(10),
    height: dynamicSize(10),
    borderRadius: 50,
    borderWidth: 1.5,
    borderColor: Colours.PRIMARY,
    position: "absolute",
    zIndex: 1,
  },

  // ── ⚡ VERTICAL TICKER TOP-UPS WORKSPACE SPECIFIC STYLES ──
  tickerOuterWrapper: {
    marginBottom: dynamicSpacing(22),
    marginTop: dynamicSpacing(4),
  },
  tickerHeaderRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingHorizontal: dynamicSpacing(4),
    marginBottom: dynamicSpacing(10),
  },
  tickerSubLink: {
    fontSize: dynamicFontSize(11),
    fontFamily: "Sen-Regular",
    color: Colours.PRIMARY,
  },
  verticalFeedStackContainer: {
    gap: dynamicSpacing(12),
    paddingHorizontal: dynamicSpacing(4),
  },
  liveVerticalItemRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "white",
    paddingVertical: dynamicSpacing(12),
    paddingHorizontal: dynamicSpacing(14),
    borderRadius: dynamicSize(14),
    // Modern borderless design built natively into the elevation system

    // shadowColor: "#000",
    // shadowOffset: { width: 0, height: 4 },
    // shadowOpacity: 0.05,
    // shadowRadius: 6,
    // elevation: 2,
  },
  liveVerticalItemLeft: {
    flexDirection: "row",
    alignItems: "center",
    gap: dynamicSpacing(12),
  },
  vividCelebrationBalloon: {
    width: dynamicSize(32),
    height: dynamicSize(32),
  },
  balloonSpaceReplacerDot: {
    width: dynamicSize(6),
    height: dynamicSize(6),
    borderRadius: 50,
    backgroundColor: "#E5E5EA",
    marginHorizontal: dynamicSpacing(13), // Aligns layout spacing with balloon footprint
  },
  metaTextBlock: {
    justifyContent: "center",
  },
  liveCardTableName: {
    fontSize: dynamicFontSize(14),
    fontFamily: "Sen-Bold",
    color: "#1F1F1F",
  },
  liveCardToppingLabel: {
    fontSize: dynamicFontSize(11),
    fontFamily: "Sen-Regular",
    color: "#8E8E93",
    marginTop: dynamicSpacing(1),
  },
  liveVerticalItemRight: {
    alignItems: "flex-end",
    gap: dynamicSpacing(4),
  },
  tickerFullSolidCapsule: {
    paddingHorizontal: dynamicSpacing(12),
    paddingVertical: dynamicSpacing(5),
    borderRadius: dynamicSize(6),
    justifyContent: "center",
    alignItems: "center",
  },
  tickerFullCapsuleText: {
    fontSize: dynamicFontSize(12),
    fontFamily: "Sen-Bold",
    color: "white",
  },
  liveCardTimeText: {
    fontSize: dynamicFontSize(10),
    fontFamily: "Sen-Regular",
    color: "#C7C7CC",
  },
});
